import "core-js/modules/es.array.push.js";
import { ref, inject } from 'vue';
import api from '@/api/index';
export default {
  setup() {
    const homeInfo = ref({});
    const homeOrder = ref({});

    // method 2
    // let homeInfo = reactive({ data: {} })
    // const echarts = getCurrentInstance().appContext.config.globalProperties.$echarts;
    const echarts = inject('echarts');
    api.getHomeCount().then(res => {
      homeInfo.value = res.data.data.list;
      // homeInfo.data = res.data.data.list
    });

    api.getHomeOrder().then(res => {
      console.log(res);
      homeOrder.value = res.data.list;
    });
    api.getHomeFormat().then(res => {
      let arr = res.data.result.data.sale_money;
      let xData = [],
        yData = [],
        yBarData = [],
        pieData = [];
      arr.forEach(ele => {
        xData.push(ele.name);
        yData.push(ele.total_amount);
        yBarData.push(ele.num);
        let obj = {};
        obj.name = ele.name;
        obj.value = ele.total_amount;
        pieData.push(obj);
      });
      bar(xData, yData, yBarData);
      pie(pieData);
    });
    const bar = (x, y, yData) => {
      const myChart = echarts.init(document.getElementById('charts'));
      const option = {
        tooltip: {},
        legend: {
          show: true,
          data: ['销售额', '销售量']
        },
        xAxis: {
          data: x
        },
        yAxis: {},
        series: [{
          name: '销售额',
          type: 'line',
          smooth: true,
          data: y
        }, {
          name: '销售量',
          type: 'bar',
          data: yData
        }]
      };
      myChart.setOption(option);
    };
    const pie = data => {
      const pieChart = echarts.init(document.getElementById('pie'));
      const pieOption = {
        title: {},
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [{
          name: '销售品类',
          type: 'pie',
          radius: '50%',
          data: data,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      pieChart.setOption(pieOption);
    };
    return {
      homeInfo,
      homeOrder
    };
  }
};